// ورود دقیقه (US-CAT-010): ارقام فارسی یا لاتین؛ مقدار فرم عدد صحیح یا null (خالی).
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useTranslation } from '@phoenix/i18n';
import { faDigits, keepDigitsOnly } from '@phoenix/ui';
import { useController, type Control, type FieldValues, type Path } from 'react-hook-form';

export function MinutesFieldRHF<T extends FieldValues>({
  control,
  name,
  labelKey,
  helperKey,
  required,
  disabled,
  nullable = false,
  testId,
}: {
  control: Control<T>;
  name: Path<T>;
  labelKey: string;
  helperKey?: string;
  required?: boolean;
  disabled?: boolean;
  /** خالی ← null (مثل مدت به ازای واحد)؛ در غیر این صورت خالی ← ۰. */
  nullable?: boolean;
  testId?: string;
}) {
  const { t } = useTranslation('cat');
  const { field, fieldState } = useController({ name, control });
  const value = typeof field.value === 'number' ? faDigits(String(field.value)) : '';
  const message = fieldState.error?.message;
  return (
    <TextField
      name={field.name}
      inputRef={field.ref}
      value={value}
      required={required}
      disabled={disabled}
      fullWidth
      label={t(labelKey)}
      error={Boolean(message)}
      helperText={message ? t(message) : helperKey ? t(helperKey) : undefined}
      onBlur={field.onBlur}
      onChange={(event) => {
        const digits = keepDigitsOnly(event.target.value);
        field.onChange(digits === '' ? (nullable ? null : 0) : Number(digits));
      }}
      slotProps={{
        htmlInput: { inputMode: 'numeric', dir: 'ltr', 'data-testid': testId },
        input: { endAdornment: <InputAdornment position="end">{t('cat:duration.minutes')}</InputAdornment> },
      }}
    />
  );
}
